module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG1001-351c9e9bfcc06bcff91cb9758ac79cef.png";